
/**
 * Semantic version compare (descending: newest first). Splits on dots, compares each
 * segment numerically so 4.10 sorts above 4.1. Non-numeric/pre-release suffixes
 * (e.g. 4.1.0-beta) fall back to a string compare on that segment.
 */
export function compareVersionsDesc(a: string, b: string): number {
  const pa = a.replace(/^v/, '').split('.')
  const pb = b.replace(/^v/, '').split('.')
  const len = Math.max(pa.length, pb.length)
  for (let i = 0; i < len; i++) {
    const sa = pa[i] ?? '0'
    const sb = pb[i] ?? '0'
    const na = parseInt(sa, 10)
    const nb = parseInt(sb, 10)
    const bothNum = !Number.isNaN(na) && !Number.isNaN(nb) && /^\d+$/.test(sa) && /^\d+$/.test(sb)
    if (bothNum) {
      if (na !== nb) return nb - na
    } else if (sa !== sb) {
      return sb.localeCompare(sa)
    }
  }
  return 0
}

/** Resolve a source_url to a known VCS host for the RepoProviderIcon mark (null = generic). */
export function repoHost(url: string | null): 'github' | 'gitlab' | null {
  if (!url) return null
  try {
    const h = new URL(url).hostname
    if (/(^|\.)github\.com$/.test(h)) return 'github'
    if (/(^|\.)gitlab\.com$/.test(h)) return 'gitlab'
  } catch { /* not a URL */ }
  return null
}

/** Human label for the upstream registry host behind a RegistryIcon mark. */
export function registryLabel(upstream: string | null | undefined): string {
  if (upstream === 'opentofu.org') return 'registry.opentofu.org'
  if (upstream === 'terraform.io') return 'registry.terraform.io'
  return 'the upstream registry'
}
